// Function to handle inch button click
function switchToInches() {
  // Set active state
  document.querySelector(".inch-btn").classList.add("active");
  document.querySelector(".cm-btn").classList.remove("active");

  // Get all convertible cells
  const convertibleCells = document.querySelectorAll(".convertible");

  // Restore original inch values
  convertibleCells.forEach((cell, index) => {
    const originalValue = cell.getAttribute("data-inch-value");
    cell.textContent = originalValue;
  });
}

// Function to handle cm button click
function switchToCm() {
  // Set active state
  document.querySelector(".cm-btn").classList.add("active");
  document.querySelector(".inch-btn").classList.remove("active");

  // Get all convertible cells
  const convertibleCells = document.querySelectorAll(".convertible");

  // Convert to cm
  convertibleCells.forEach((cell) => {
    const inchValue = parseFloat(cell.getAttribute("data-inch-value"));
    const cmValue = (inchValue * 2.54).toFixed(1);
    cell.textContent = cmValue;
  });
}

// Function to show popup
function showPopup() {
  const overlay = document.querySelector(".overlay");
  overlay.classList.add("active");
  document.body.style.overflow = "hidden"; // Prevent scrolling
}

// Function to hide popup
function hidePopup() {
  const overlay = document.querySelector(".overlay");
  overlay.classList.remove("active");
  document.body.style.overflow = "";
}

// Setup close on outside click
document.addEventListener("DOMContentLoaded", function () {
  // Close popup when clicking outside
  const overlay = document.querySelector(".overlay");
  if (overlay) {
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        hidePopup();
      }
    });
  }

  // Close popup when pressing ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      hidePopup();
    }
  });

  // Store original inch values as data attributes when page loads
  const convertibleCells = document.querySelectorAll(".convertible");
  convertibleCells.forEach((cell) => {
    const inchValue = parseFloat(cell.textContent);
    cell.setAttribute("data-inch-value", inchValue);
  });
});
